import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

interface EditorialBulletListProps {
  items: string[];
  /** Sur une bande de couleur pleine, le texte et la puce passent en blanc. */
  onSolid?: boolean;
}

// Extrait de `OurValues.view` pour que toutes les pages éditoriales partagent exactement le même
// rendu de puces. Recopié, il aurait divergé à la première retouche sans que personne le voie.
const useStyles = makeStyles((theme) => ({
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  item: {
    position: 'relative',
    paddingLeft: '1.5rem',
    fontSize: '0.98rem',
    lineHeight: 1.6,
    color: '#3d3d3d',

    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '0.6em',
      width: '0.5rem',
      height: '0.5rem',
      borderRadius: '50%',
      backgroundColor: theme.palette.client.primary.main,
    },
  },
  itemOnSolid: {
    color: '#fff',

    '&:before': {
      backgroundColor: '#fff',
    },
  },
}));

const EditorialBulletList: React.FC<EditorialBulletListProps> = ({ items, onSolid = false }) => {
  const classes = useStyles();

  return (
    <ul className={classes.list}>
      {items.map((item) => (
        <li key={item} className={`${classes.item} ${onSolid ? classes.itemOnSolid : ''}`}>
          {item}
        </li>
      ))}
    </ul>
  );
};

export default EditorialBulletList;
